import { render, staticRenderFns } from "./BuyBuildPanel.vue?vue&type=template&id=48fb0575&scoped=true"
import script from "./BuyBuildPanel.vue?vue&type=script&lang=js"
export * from "./BuyBuildPanel.vue?vue&type=script&lang=js"
import style0 from "./BuyBuildPanel.vue?vue&type=style&index=0&id=48fb0575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fb0575",
  null
  
)

export default component.exports